import { Grid, Typography } from '@material-ui/core'
import StandardTable from 'asterX-UI/Table/StandardTable'
import React, { useEffect, useState } from 'react'
import { CollectionService } from 'lib/api/services/collection.service'
import { financeTableColumns, financeTableRows, resultOverdueTranchesRows } from './const'
import { useStyles } from './finance-table.styles'

export const FinanceTable = ({ tableType, contract }) => {
  const classes = useStyles()

  const [financeTableData, setFinanceTableData] = useState([])

  useEffect(() => {
    if (tableType && contract?.contractId) {
      getFinanceTableData()
    }
  }, [tableType, contract?.contractId])

  const getFinanceTableData = async (limit = 10000, offset = 0) => {
    if (!contract?.contractId || !tableType) {
      return
    }
    const data = {
      contractId: contract?.contractId,
      offset,
      limit
    }
    const res = await CollectionService.getFinanceTableData(data, tableType)
    if (res?.data) {
      setFinanceTableData(res?.data?.list)
    }
    return res
  }

  const sortByDate = (a, b, dateField) => new Date(a[dateField]) - new Date(b[dateField])
  const sortedFinanceTableData = financeTableData.slice().sort((a, b) => sortByDate(a, b, 'repaymentDate'))

  const tableData = {
    columns: financeTableColumns(tableType),
    rows: financeTableRows(tableType, sortedFinanceTableData)
  }

  const resultTableData = {
    columns: ['Вид суммы', 'Баланс', 'Итого'],
    rows: resultOverdueTranchesRows(financeTableData)
  }

  const overdueTranchesTotal = tableType === 'overdueTranches' ? [1, 3] : null
  const resultOverdueTranchesTotal = tableType === 'overdueTranches' ? [1, 2] : null
  return (
    <Grid container className={classes.wrapper}>
      <Grid item className={tableType !== 'overdueTranches' ? classes.tableContainer : ''} style={{ overflow: 'auto' }}>
        {tableType === 'overdueTranches' && (
          <Typography variant="h6" className={classes.title}>
            Раскладка по просроченным траншам
          </Typography>
        )}

        <StandardTable
          tableData={tableData}
          btnStyle={{ backgroundColor: 'transparent', border: 'none', padding: 8, minWidth: 'auto' }}
          columnsToTotal={overdueTranchesTotal}
        />
      </Grid>

      {tableType === 'overdueTranches' && (
        <Grid item style={{ overflow: 'auto' }}>
          <Typography variant="h6" className={classes.title}>
            Итог по просроченным траншам
          </Typography>
          <StandardTable
            tableData={resultTableData}
            btnStyle={{ backgroundColor: 'transparent', border: 'none', padding: 8, minWidth: 'auto' }}
            columnsToTotal={resultOverdueTranchesTotal}
          />
        </Grid>
      )}
    </Grid>
  )
}
